import React from 'react'
import { Link } from 'react-router-dom'
// Import Img
import Img1 from "../../assets/img/common/about.png"
import Img2 from "../../assets/img/icon/about.png"
// import Commonent
import ReadyHelp from './ReadyHelp'
import PartnerArea from '../Home/Partner'
import Newsletter from './Newsletter'
import Testimonials from './Testimonials'


const AboutArea = () => {
  return (
    <>
   <section id="about_area" className="section_padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="about_area_img">
                        <img src={Img1} alt="img" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="about_area_main_text">
                        <div className="about_area_heading">
                            <img src={Img2} alt="img" />
                            <h3>About PCF</h3>
                        </div>
                        <div className="about_area_heading_two">
                            <h2><span className="color_big_heading">Culture</span>, education &amp; integration <br />
                                — badminton first</h2>
                            <h3>Serving the Pakistani community in Sweden</h3>
                        </div>
                        <div className="about_area_para">
                            <h5>PCF is volunteer-led. We believe children flourish when heritage, school success, and life in
                                Swedish society all strengthen together.</h5>
                            <p>We combine homework and language support with <strong>integration activities</strong>—clear information,
                                peer networks, and safe spaces to ask “how does this work in Sweden?”. <strong>Badminton</strong> is our
                                main sport year-round; we layer in <strong>swimming</strong>, <strong>cricket</strong>, and <strong>football</strong> by season, and host
                                <strong>social gatherings</strong> that mix generations.</p>
                            <p>We welcome families from across Sweden. Register for badminton, join a seasonal block, come to a
                                culture or integration evening, or volunteer—there is a place for you at PCF.</p>
                        </div>
                        <div className="about_vedio_area">
                            <Link to="/contact" className="btn btn_theme btn_md">Contact us</Link>
                            <a href="#!" className="vedio_btn popup-vimeo"><i
                                    className="fa fa-play"></i>Our story</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <ReadyHelp/>
    <PartnerArea/>
    <Newsletter/>
    <Testimonials/>

    </>
  )
}

export default AboutArea